/**
 * holo-cards.js — gives product cards a 3D "foil card" tilt + glare that follows the cursor.
 * Desktop + motion-allowed only. Binds lazily per card (listeners attach on first hover) and
 * rescans for cards that hydrate late (carousels) or load in the theme editor.
 */
const HOLO_REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)');
const HOLO_FINE = window.matchMedia('(pointer: fine)');
const HOLO_SELECTOR = '.product-card, .resource-card, .hawg-card';
const HOLO_MAX = 9; // max tilt in degrees

function initHolo() {
  if (HOLO_REDUCE.matches || !HOLO_FINE.matches) return;

  const bound = new WeakSet();

  const bind = (card) => {
    if (bound.has(card) || card.closest('.fd-card')) return; // skip the featured-drop card
    bound.add(card);

    const media =
      card.querySelector('.product-card-gallery, .card-gallery, .resource-card__media, .hawg-card__media') ||
      card;
    let glare = null;
    let raf = 0;
    let px = 0;
    let py = 0;

    const apply = () => {
      raf = 0;
      card.style.setProperty('--holo-rx', `${(-py * HOLO_MAX).toFixed(2)}deg`);
      card.style.setProperty('--holo-ry', `${(px * HOLO_MAX).toFixed(2)}deg`);
      card.style.setProperty('--holo-mx', `${((px + 0.5) * 100).toFixed(1)}%`);
      card.style.setProperty('--holo-my', `${((py + 0.5) * 100).toFixed(1)}%`);
    };

    card.addEventListener('pointerenter', () => {
      if (!glare) {
        glare = document.createElement('span');
        glare.className = 'holo-glare';
        glare.setAttribute('aria-hidden', 'true');
        if (getComputedStyle(media).position === 'static') media.style.position = 'relative';
        media.appendChild(glare);
      }
      card.classList.add('holo-active');
    });

    card.addEventListener(
      'pointermove',
      (e) => {
        const r = card.getBoundingClientRect();
        px = (e.clientX - r.left) / r.width - 0.5;
        py = (e.clientY - r.top) / r.height - 0.5;
        if (!raf) raf = requestAnimationFrame(apply);
      },
      { passive: true }
    );

    card.addEventListener('pointerleave', () => {
      card.classList.remove('holo-active');
      if (raf) cancelAnimationFrame(raf);
      raf = 0;
      card.style.removeProperty('--holo-rx');
      card.style.removeProperty('--holo-ry');
    });
  };

  const scan = (root = document) => {
    (root.querySelectorAll ? root.querySelectorAll(HOLO_SELECTOR) : []).forEach(bind);
  };

  scan();
  window.addEventListener('load', () => scan());
  setTimeout(() => scan(), 1500); // catch late-hydrating carousels
  document.addEventListener('shopify:section:load', (e) => scan(e.target));
}

if (document.readyState !== 'loading') initHolo();
else document.addEventListener('DOMContentLoaded', initHolo);
